import React, { ComponentType, ReactNode, useEffect, useState } from "react";

import { Feature } from "@formant/core/model/Feature";

import { useLogger } from "../context/LoggerContext";
import { useStores } from "../context/StoreContext";

export interface IPaywallProps {
    feature: Feature;
    ErrorPage?: ComponentType;
    children?: ReactNode;
}

export function Paywall(props: IPaywallProps) {
    const { ErrorPage, children, feature } = props;
    const { authStore } = useStores();
    const logger = useLogger();

    const [enabled, setEnabled] = useState<boolean | undefined>(undefined);

    useEffect(() => {
        setEnabled(undefined);
        (async () => {
            const enabledFeatures = await authStore.fetchFeatures();
            setEnabled(enabledFeatures.includes(feature));
        })().catch(error => {
            logger.warn("unable to request features", { error });
        });
    }, [authStore, setEnabled, feature, logger]);

    if (enabled === undefined) {
        return null;
    }

    if (!enabled) {
        if (ErrorPage) {
            logger.warn(`Feature not enabled: ${feature}`);
        }
        return ErrorPage ? <ErrorPage /> : null;
    }

    return <>{children}</>;
}
